<template>
  <div class="container list_box">
    <scroll :data="dataList" v-if="dataList.length && loaded" :allLoaded="allLoaded" @pulldown="loadData" @loadUp="loadup">
      <section class="list_item border-bottom" v-for="(item,index) in dataList" :key="index" @click="toConsultationDetail(item.id)">
        <h2>{{item.title}}</h2>
        <section class="item_bottom">
          <p class="item_bottom_left">提交咨询时间:{{item.createTime | timeType}}</p>
        </section>
        <span :class="['status',item.status==0?'submitted':'']">{{item.status == 0 ? '待处理':'已处理'}}</span>
      </section>
    </scroll>
    <no-message v-if="!dataList.length && loaded"></no-message>
  </div>
</template>

<script>
import Scroll from "../../components/scroll";
import util from "../../utils/util";
import { getAdviceByUserId } from "../../utils/api";
import NoMessage from '../../components/nomessage';
import { mapState } from "vuex";
export default {
  name: "myConsultation",
  data() {
    return {
      allLoaded: false,
      pageNo:1,
      pageSize:10,
      dataList: [],
      loaded:false,
      status:0
    }
  },
  filters: {
    timeType(val) {
      return util.formatTime(new Date(Number(val)), 10);
    }
  },
  components: {
    Scroll,
    NoMessage
  },
  computed:{
    ...mapState({
      common:state => state.common
    })
  },
  created(){
    this.getAdviceByUserId()
  },
  methods: {
    getAdviceByUserId(){
      let params = {
        pageSize:this.pageSize,
        pageNo:this.pageNo,
        userId:this.common.userId
      }
      this.allLoaded = false
      getAdviceByUserId(params).then(res=>{
        console.log(res)
        this.loaded = true;
        if(res.res.code === 10000 && res.body && res.body.page){
          if(res.body.page.rows.length !== 10){
            this.allLoaded = true
          }
          if(this.pageNo == 1){
            this.dataList = res.body.page.rows || []
          }else{
            this.dataList = [...this.dataList,...res.body.page.rows]
          }
        }else{
          util.showToast(res.res.msg)
        }
        util.hideLoading()
      })
    },
    // 上拉加载
    loadup() {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.getAdviceByUserId()
    },
    // 下拉刷新
    loadData() {
      this.pageNo = 1;
      util.showLoading();
      this.getAdviceByUserId()
    },
    toConsultationDetail(id){
      this.$router.push(`/myConsultationDetail?id=${id}`)
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #fff;
}
.list_box {
  height:100vh;
  .list_item {
    padding: 28px;
    position:relative;
    h2 {
      font-size: 32px;
      color: rgba(24, 24, 24, 1);
      line-height: 44px;
      min-height: 88px;
      margin-bottom: 18px;
      word-break: break-all;
      max-width:80%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
     white-space: pre-line;
    }
    .status{
      position: absolute;
      top:28px;right:28px;
      font-size:24px;
      line-height:32px;
      color:#16BC84;
    }
    .submitted{
      color:#FFAD5D;
    }
    .item_bottom {
      .flex();
      align-items: center;
      .item_bottom_left {
        font-size: 28px;
        color: rgba(153, 153, 153, 1);
        line-height: 40px;
      }
    }
  }
}
</style>